import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Label as SemanticLabel, } from 'semantic-ui-react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import { colorVars, colorShortToLong, INHERIT } from '../../../utils/colors';
import { ColorNames } from '../../../constants/colorVars';
import Icon from '../icon';
import { LightenDarkenColor } from './lightDarkenColor';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const DARKEN_PERCENTAGE = -20;
const RibbonContent = ({ title, iconProps, className, }) => {
    return (_jsxs("div", { className: cx('ribbon-content', className), children: [typeof iconProps === 'object' && (_jsx(Icon, { fitted: _.isNil(iconProps.fitted) ? true : iconProps.fitted, name: iconProps.name, iconStyle: iconProps.iconStyle || 'solid', color: iconProps.color || 'white' })), _jsx("div", { children: title })] }));
};
const Ribbon = ({ className = '', children, color: colorName = ColorNames.Gray, darkText = false, style, elmId = '', ...rest }) => {
    const colorKey = useMemo(() => colorShortToLong(colorName || ''), [colorName]);
    const color = useMemo(() => colorName === INHERIT
        ? INHERIT
        : colorVars[colorKey] || '#000000', [colorName, colorKey]);
    const shadedColor = useMemo(() => LightenDarkenColor(color, DARKEN_PERCENTAGE), [color]);
    return (_jsx(SemanticLabel, { "data-elm-id": elmId || 'ribbon', ribbon: true, className: cx('ribbon', { 'dark-text': darkText }, className), style: { backgroundColor: color, borderColor: shadedColor, ...style }, ...rest, children: children }));
};
const RibbonWithStatic = Ribbon;
RibbonWithStatic.Content = RibbonContent;
export default RibbonWithStatic;
//# sourceMappingURL=index.js.map